import moment from "moment";

export const displayFormat = "DD.MM.YYYY";
export const ymdDateFormat = "YYYY-MM-DD";
export const displayFormatWithTime = `${displayFormat} HH:mm:ss`;
export const displayFormatOnlyTime = "HH:mm:ss.SSS";
export const infinityStartDateHttpFormat = "1970-01-01T00:00:00.000+00:00";
export const infinityDateHttpFormat = "2999-12-31T23:59:59.000+00:00";
export const uploadPriceFormat = "YYYY-MM-DDTHH:mm:ssZ";

export const toDisplayFormat = (date) => {
  if (date) {
    return moment(date).format(displayFormat);
  }
  throw new Error("Invalid date");
};

export const toDisplayFormatWithTime = (date) => {
  if (date) {
    return moment(date).format(displayFormatWithTime);
  }
  throw new Error("Invalid date");
};

export const toHttpFormat = (date) => {
  if (date) {
    return moment(date).format("YYYY-MM-DDTHH:mm:ss.SSSZ");
  }
  throw new Error("Invalid date");
};

export const toHttpFormatStartOfDay = (date, dateFormat) => {
  if (date) {
    const momentDate = dateFormat ? moment(date, dateFormat) : moment(date);
    return momentDate.startOf("day").format("YYYY-MM-DDTHH:mm:ss.SSSZ");
  }
  throw new Error("Invalid date");
};

export const toHttpFormatEndOfDay = (date) => {
  if (date) {
    return moment(date).endOf("day").format("YYYY-MM-DDTHH:mm:ss.SSSZ");
  }
  throw new Error("Invalid date");
};

export const toYearMonthDayLineFormat = (date) => {
  if (date) {
    return moment(date).format("YYYY-MM-DD");
  }
  throw new Error("Invalid date");
};
export const toDisplayFormatOnlyTime = (date) => {
  if (date) {
    return moment(date).format(displayFormatOnlyTime);
  }
  throw new Error("Invalid date");
};

export default {
  toDisplayFormat,
  toDisplayFormatWithTime,
  toHttpFormat,
  toHttpFormatStartOfDay,
  toHttpFormatEndOfDay,
  toYearMonthDayLineFormat,
};
